import * as React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container, Grid, Box, Button, Divider } from '@mui/material';
import useWindowDimensions from "../../utils/useWindowDimensions";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import makeStyles from "@mui/styles/makeStyles";
import { useLocation } from "react-router-dom";
import { LoderSimmer } from "../../components";
import { GET_PROPERTY_AMENITIES_DETAILS, GET_UNIT_AMENITIES } from '../../graphql/queries';
import { NetworkCall } from '../../networkcall';
import { AlertProps, calculateDaysBetweenDates, FontFamilySwitch, getMonth, NetWorkCallMethods } from '../../utils';
import { config } from '../../config';
import { AlertContext } from "../../contexts";
import moment from 'moment';
import Paymentscreen from './paymentscreen';
import { withNamespaces } from 'react-i18next';
import { withBottombar } from '../../HOCs';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: "0px",
        backgroundColor: '#F2F5FA',
    },
    tagStyle: {
        backgroundColor: "#F1E6FE",
        borderRadius: "4px",
        padding: "4px 6px 4px 6px",
        fontSize: "0.75rem",
        fontFamily: FontFamilySwitch().bold,
        color: "#5D427F",
        textTransform: "uppercase",
        marginLeft: "8px",
    },
    tagStyle1: {
        backgroundColor: "#F1E6FE",
        borderRadius: "4px",
        padding: "4px 6px 4px 6px",
        fontSize: "0.75rem",
        fontFamily: FontFamilySwitch().bold,
        color: "#5D427F",
        textTransform: "uppercase",
        marginLeft: "8px",
    },
    title: {
        color: '#071741',
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().bold,
    },
    sub: {
        color: '#98A0AC',
        fontFamily: FontFamilySwitch().semiBold,
        fontSize:"0.75rem",
    },
    amount: {
        color: '#091B29',
        fontFamily: FontFamilySwitch().extraBold,
        fontSize: "1.25rem",
        fontWeight: 600
    },
    date: {
        color: '#091B29',
        fontFamily: FontFamilySwitch().extraBold,
        fontSize: "0.875rem",
    },
    main: {
        backgroundColor: '#F5F7FE',
        borderRadius: '4px',
        padding: '15px'
    },
    accordion: {
        borderRadius: '4px !important',
    },
    paymentbtn: {
        borderRadius: '4px',
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().bold,
        width: '100%',
        padding: '9px',
        '&hover': {
            backgroundColor: '#5078E1'
        }
    },
    btnParent: {
        padding: '14px',
        margin: "0 auto",
        textAlign: 'center',
        background: '#F2F5FA',
        zIndex: 2
    },
    topDrap: {
        backgroundColor: '#5C86F6',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1px 15px 1px 15px',
        cursor: 'pointer'
    },
    toptitle: {
        color: '#fff',
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().bold,
    },
    rationame: {
        '&.MuiFormControlLabel-label': {
            color: '#091B29',
            fontSize: "0.875rem",
            fontFamily: FontFamilySwitch().bold,
        }
    },
    noData: {
        color: "#999",
        textAlign: "center",
        marginTop: "20vh",
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().bold,
        marginLeft: "12px"
    }
}));


const AmenitiesType = ({t = () => false, handleTopBarState}) => {
    const classes = useStyles();
    const size = useWindowDimensions();
    const alert = React.useContext(AlertContext);
    const [details, setDetails] = React.useState([])
    const searchURL = useLocation().search;
    const amenityName = new URLSearchParams(searchURL).get("name");
    const AmenityId = new URLSearchParams(searchURL).get("Id");
    const type = new URLSearchParams(searchURL).get("type");
    const [paymentDrawer, setPaymentDrawer] = React.useState(false);
    const [alreadypayed, setAlreadypayed] = React.useState(false);
    const [totalBill, setTotalBill] = React.useState("");
    const [companyId, setCompanyId] = React.useState("");
    const [loading, setLoading] = React.useState(true);


    const closePayment = () => {
        setPaymentDrawer(!paymentDrawer)
    }

    const closeAllreadyPayment = () => {
        setAlreadypayed(!alreadypayed)
    }



    const DetailsAgainstAmenity = () => {
        const data = {
            query: GET_UNIT_AMENITIES,
            variables: {
                unit_amenities_id: AmenityId,
            },
        };
        NetworkCall(
            `${config.graphql_url}`,
            NetWorkCallMethods.post,
            data,
            null,
            true,
            false
        )
            .then((response) => {

                setDetails(response?.data?.data?.ameneties_usage)
                setTotalBill(response?.data?.data?.ameneties_usage?.[0]?.total_bill)
                setCompanyId(response?.data?.data?.ameneties_usage?.[0]?.invoice?.[0]?.company_id)
                setLoading(false)
            })
            .catch((error) => {
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.error,
                    msg: t("SomethingWentwrong"),
                });
            });
    }
    const DetailsAgainstPropertyAmenity = () => {
        const data = {
            query: GET_PROPERTY_AMENITIES_DETAILS,
            variables: {
                property_facilities_id: AmenityId,
            },
        };
        NetworkCall(
            `${config.graphql_url}`,
            NetWorkCallMethods.post,
            data,
            null,
            true,
            false
        )
            .then((response) => {

                setDetails(response?.data?.data?.ameneties_usage)
                setTotalBill(response?.data?.data?.ameneties_usage?.[0]?.total_bill)
                setCompanyId(response?.data?.data?.ameneties_usage?.[0]?.invoice?.[0]?.company_id)
                setLoading(false)
            })
            .catch((error) => {
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.error,
                    msg: t("SomethingWentwrong"),
                });
            });
    }




    React.useEffect(() => {
        handleTopBarState({
            text: amenityName,
            isUtilities: true
          })
        if (type === "unit") {
            DetailsAgainstAmenity()
        }
        if (type === "property") {
            DetailsAgainstPropertyAmenity()
        }
        // eslint-disable-next-line
    }, [])
    console.log(totalBill)

    return (
        <Container className={classes.root} maxWidth="sm" style={{ height: size?.height }}>
            {/* <TitleBar
                text={amenityName}

                isUtilities
                goBack={() => history.goBack()}
            /> */}
            {loading ? <LoderSimmer count={20} /> :
                <>
                    {details.length > 0 ?
                        <>
                            <div style={{ height: size?.height - 145, overflow: 'auto', paddingBottom: '20px' }}>
                                {
                                    details?.map((x, index) => {
                                        return (
                                            <div style={{ padding: '16px 4px 0px 10px' }}>
                                                <AccordionComponent data={x} index={index} setTotalBill={setTotalBill} setCompanyId={setCompanyId} />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <Box className={classes.btnParent}>
                                <Button className={classes.paymentbtn} variant='contained' onClick={closePayment}>{t("PayNow")}</Button>
                            </Box>
                        </> : <Typography className={classes.noData}>
                            {t("Datanotfound")}
                        </Typography>

                    }
                </>
            }
            {/* payment */}
            {paymentDrawer &&
                <Paymentscreen closePayment={closePayment} closeAllreadyPayment={closeAllreadyPayment} alreadypayed={alreadypayed} paymentDrawer={paymentDrawer} companyId={companyId} />
            }



        </Container>
    );
}

const AccordionComponent = (props) => {
    const {t} = props
    const classes = useStyles();

    const dueDate = calculateDaysBetweenDates(new Date(props?.data?.invoice?.[0]?.payment_due_date), new Date(Date.now()))

    // const dueDate = new Date(props?.data?.[1][props?.data?.[1].length - 1].invoice[0].payment_due_date)
    return (
        <Accordion className={classes.accordion} TransitionProps={{ unmountOnExit: true }} defaultExpanded={props?.index === 0 ? true : false}
            onChange={() => {
                props?.setTotalBill(props?.data?.total_bill)
                props?.setCompanyId(props?.data?.invoice?.[0]?.company_id)
            }
            }
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#071741' }} />} aria-controls='panel1a-content' id='panel1a-header'>
                <Typography style={{ display: 'flex', alignItems: 'center' }} className={classes.title}>
                    {
                        getMonth(new Date(props?.data?.created_at).getMonth())
                    }
                    <span
                        className={dueDate > 0 ? classes.tagStyle1 : classes.tagStyle}
                    >
                        {
                            dueDate > 0 ? dueDate + "  " + t("daystodue") : t("overdue")
                        }
                    </span>
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className={classes.main}>
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box>
                                    <img src='/images/utilitiesinvoices.svg' alt='invoice' />
                                </Box>
                                <Box style={{ marginLeft: '16px' }}>
                                    <Typography className={classes.sub}>{t("TotalBill")}</Typography>
                                    <Typography className={classes.amount}>{props?.data?.total_bill}</Typography>
                                </Box>
                            </Box>

                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box>
                                    <img src='/images/meter.svg' alt='invoice' />
                                </Box>
                                <Box style={{ marginLeft: '16px' }}>
                                    <Typography className={classes.sub}>{t("NumberOfHours")}</Typography>
                                    <Typography className={classes.amount}>{props?.data?.total_hours}</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    {/* 2nd */}
                    <Grid item xs={6}>
                        <Box style={{ display: 'flex', alignItems: 'center' }} className={classes.main}>
                            <Box>
                                <img src='/images/utilitiescalander.svg' alt='invoice' />
                            </Box>
                            <Box style={{ marginLeft: '16px' }}>
                                <Typography className={classes.sub}>{t("BookedFrom")}</Typography>
                                <Typography className={classes.date}>
                                    {moment(props?.data?.from).format("DD MMM YY")}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box style={{ display: 'flex', alignItems: 'center' }} className={classes.main}>
                            <Box>
                                <img src='/images/utilitiescalander.svg' alt='invoice' />
                            </Box>
                            <Box style={{ marginLeft: '16px' }}>
                                <Typography className={classes.sub}>{t("BookedTo")}</Typography>
                                <Typography className={classes.date}>
                                    {moment(props?.data?.to).format("DD MMM YY")}

                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    {/* 3rd */}
                    <Grid item xs={12}>
                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className={classes.main}>
                            <Box>
                                <Typography className={classes.sub}>{t("BookedOnDate")}</Typography>
                                <Typography className={classes.date}>
                                    {moment(props?.data?.from).format("DD MMM YY")}
                                </Typography>                            </Box>
                            <Box>
                                <img src='/images/bookedicon.svg' alt='bookedicon' />
                            </Box>
                        </Box>
                    </Grid>
                    {/* 4th */}
                    <Grid item xs={12}>
                        <Box style={{ display: 'flex', alignItems: 'center' }} className={classes.main}>
                            <Box>
                                <img src='/images/utilitiescalander.svg' alt='invoice' />
                            </Box>
                            <Box style={{ marginLeft: '16px' }}>
                                <Typography className={classes.sub}>{t("PerHourPrice")}</Typography>
                                <Typography className={classes.date}>
                                    {`${props?.data?.invoice?.[0]?.currency_master?.symbol} ${props?.data?.rate_per_hour}`}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    {props?.data?.paid_on &&
                        <>
                            <Grid item xs={12}>
                                <Box style={{ display: 'flex', alignItems: 'center' }} className={classes.main}>
                                    <Box>
                                        <img src='/images/utilitiescalander.svg' alt='invoice' />
                                    </Box>
                                    <Box style={{ marginLeft: '16px' }}>
                                        <Typography className={classes.sub}>{t("PaidOn")}</Typography>
                                        <Typography className={classes.date}>
                                            {moment(props?.data?.paid_on).format("DD MMM YY")}

                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12} textAlign="center">
                                <Button variant='text' >
                                    {t("ViewInvoice")}
                                </Button>
                            </Grid>

                        </>
                    }

                </Grid >
            </AccordionDetails>
        </Accordion>
    )
}

const props = {
    top_bar: "title_bar",
  }

export default withBottombar(withNamespaces("amenitiesDetails")(AmenitiesType), props);


